<div class="frame" [ngClass]="{'no-background': isNoBackground}">
    <header>
        <mat-card class="report">
            <app-header [title]="reportTypeName"></app-header>
            <app-sub-header [headerRatio21]="headerRatio21" [reportOptions]="reportOptions" [legend]="legend" [showLegend]="showLegend" [showLegendIcon]="showLegendIcon"></app-sub-header>
        </mat-card>
    </header>
           
    <main [ngClass]="{'no-content-rules': noContentCss }" >
        <table class="print-table" *ngIf="useTableContent">
            <thead>
                <tr>
                    <td>                                
                        <div class="header-space"></div>
                    </td>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>
                        <ng-content select="[slot=table]"></ng-content>
    
                        <!-- <div class="report-details" [ngClass]="{'no-background': isNoBackground}">
                        </div> -->
    
                    </td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <td>
                        <!--placeholder for the fixed-position footer-->
                        <div class="footer-space"></div>
                    </td>
                    </tr>
            </tfoot>
        </table>
        <div *ngIf="!useTableContent">
            <ng-content select="[slot=notable]"></ng-content>
        </div>
    </main>
    
    <footer>
        <div class="margin-area"></div>
        <mat-card>
            <mat-card-content>
                <div class="left-block"></div>
                <div class="center-block">
                    {{ 'REPORT_FRAME.COPYRIGHT' | translate }}
                </div>
                <div class="right-block">
                    <a mat-flat-button *ngIf="showSziluettHelpButton()" class="bt-report-help button-bg-alt1 hidden-print" title="{{ 'REPORT_FRAME.HELP_BUTTON' | translate }}" href="{{ 'REPORT_FRAME.HELP_LINK' | translate }}" target="_blank">
                        {{ 'REPORT_FRAME.HELP_BUTTON' | translate }}
                    </a>
                </div>
            </mat-card-content>
        </mat-card>
    </footer>
</div>
